class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-swiper-announcement-bar]');
    this.swiperOptions = {
      autoplay: true,
      direction: 'horizontal',
      grabCursor: true,
      loop: true,
      observer: true,
      slidesPerView: 1,
      threshold: 10
    }

    // Check if we have extra options on the HTML
    if (this.swiperElement) {
      const jsonOptions = JSON.parse(this.swiperElement.dataset.swiperAnnouncementBar);

      if (jsonOptions) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...jsonOptions
        }
      }
    }

    if (this.swiperElement !== null) {
      this.init();
    }

    if (Shopify.designMode) {
      window.addEventListener('shopify:section:load',this.init.bind(this));
      window.addEventListener('shopify:block:select',this.init.bind(this));
    }
  }

  init() {
    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
